/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconEqualDouble = createReactComponent("outline", "equal-double", "IconEqualDouble", [["path", { "d": "M3 10h7", "key": "svg-0" }], ["path", { "d": "M3 14h7", "key": "svg-1" }], ["path", { "d": "M14 10h7", "key": "svg-2" }], ["path", { "d": "M14 14h7", "key": "svg-3" }]]);

export { IconEqualDouble as default };
//# sourceMappingURL=IconEqualDouble.mjs.map
